module.exports = __webpack_public_path__ + "img/SVG3_AboutYou.457c5e18.svg";